import React from 'react';
import { Link } from 'react-router-dom';
import { Radar, FolderArchive, Wallet, BellRing, LogIn, UserPlus } from 'lucide-react';

const items = [
  {
    icon: Radar,
    title: 'Трекінг у реальному часі',
    text: 'Відстежуйте точне місцезнаходження та статус кожної посилки на будь-якому етапі шляху.',
  },
  {
    icon: FolderArchive,
    title: 'Історія замовлень та інвойсів',
    text: 'Всі ваші викупи, звіти та фінансові документи зберігаються в захищеному архіві й доступні в один клік.',
  },
  {
    icon: Wallet,
    title: 'Управління балансом',
    text: 'Швидке поповнення рахунку та прозора оплата послуг логістики й викупу прямо з кабінету.',
  },
  {
    icon: BellRing,
    title: 'Сповіщення',
    text: 'Отримуйте оперативні оновлення про прибуття товарів на склад та готовність до відправки.',
  },
];

export const CabinetBenefits = () => (
  <section className="py-16 relative overflow-hidden" id="cabinet">
    <div className="absolute -top-20 left-1/4 w-96 h-96 bg-blue-600/15 rounded-full blur-3xl pointer-events-none" />
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative">
      <div className="relative rounded-3xl border border-blue-500/30 bg-[#0a1224]/90 backdrop-blur-xl shadow-[0_0_60px_-20px_rgba(59,130,246,0.5)] p-8 md:p-12 overflow-hidden">
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-cyan-400/60 to-transparent" />
        <div className="absolute -bottom-24 -right-24 w-72 h-72 bg-cyan-500/10 rounded-full blur-3xl pointer-events-none" />

        <div className="text-center max-w-3xl mx-auto mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-cyan-500/15 border border-cyan-500/40 text-cyan-300 text-xs font-semibold mb-4">Особистий кабінет</span>
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3">
            Особистий кабінет — повний контроль вашої логістики <span className="text-cyan-400">24/7</span>
          </h2>
          <p className="text-slate-400">
            Керуйте своїми доставками з Китаю та США в одному місці. Наш особистий кабінет розроблений для того, щоб ваш бізнес працював без пауз і зайвих питань.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-5 mb-10">
          {items.map((it, i) => (
            <div key={i} className="flex items-start gap-4 rounded-2xl border border-blue-500/20 bg-slate-900/50 p-5 hover:border-cyan-400/50 hover:shadow-[0_0_20px_-8px_rgba(6,182,212,0.4)] transition-all">
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-cyan-400 to-blue-600 flex items-center justify-center flex-shrink-0 shadow-[0_0_15px_rgba(6,182,212,0.4)]">
                <it.icon className="w-5 h-5 text-white" />
              </div>
              <div>
                <h3 className="text-white font-bold mb-1">{it.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed">{it.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          <Link
            to="/login"
            className="px-7 py-3 rounded-full bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-bold flex items-center gap-2 shadow-[0_0_20px_rgba(6,182,212,0.5)] hover:shadow-[0_0_30px_rgba(6,182,212,0.8)] transition-all"
            data-testid="cabinet-login-btn"
          >
            <LogIn className="w-4 h-4" />
            Увійти в особистий кабінет
          </Link>
          <Link
            to="/register"
            className="px-7 py-3 rounded-full border border-blue-500/40 text-blue-300 font-semibold flex items-center gap-2 hover:border-cyan-400 hover:text-cyan-300 hover:shadow-[0_0_15px_rgba(6,182,212,0.3)] transition-all"
            data-testid="cabinet-register-btn"
          >
            <UserPlus className="w-4 h-4" />
            Реєстрація
          </Link>
        </div>
      </div>
    </div>
  </section>
);
